<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
  import Sidebar from './components/partials/Sidebar.vue'
  import axios from 'axios'

axios.defaults.baseURL = process.env.VUE_APP_API_URL


  export default {
    name: 'app',
    components: {
      Sidebar
    }
  }
</script>


<style lang="scss">
    @import 'assets/fonts/Paygate/style.css';
    @import './assets/multiselect.css';

    .multiselect__input {
        width:100% !important;
    }
    .multiselect__tag {
        z-index:2222;
    }
    .multiselect {
        min-height:0px !important;
    }
    .multiselect__tags {
         min-height:0px !important;
    }
    .vdp-datepicker__clear-button{
        color:#FF5E5E;
        font-size:22px;
        line-height: 0;
        position: absolute;
        top: 18px;
        right: 10px;
        & i{
            font-style:normal;
        }
    }

    .error-toast {
        top: -50px !important;
        right: -82px !important;
        border-radius: 8px !important;
        font-size: 0.8125em !important;
        font-family: Montserrat-Regular;
        border: 2px solid #FF4141;
        color: black !important;
        background-color: white !important;
        width: 230px !important;
        height: 90px !important;
        word-break: break-all;
    }
    .success-toast {
        top: -50px !important;
        right: -82px !important;
        border-radius: 8px !important;
        font-size: 0.8125em !important;
        font-family: Montserrat-Regular;
        border: 3px solid #7ED321;
        color: black !important;
        background-color: white !important;
        width: 230px !important;
        height: 90px !important;
        word-break: break-all;
    }
    .page-header {
        font-family: Montserrat-SemiBold;
        >div {
            font-size: 24px;
        }
        margin-top: 50px;
        >p {
            font-family: Montserrat-Light;
            font-size: 14px;
            text-transform: none;
            margin-top: 0px;
            margin-bottom: 30px;
        }
        text-transform: uppercase;
    }
    .big-toast {
        font-size: 22px !important;
        width: 250px !important;
        height: 120px !important;
    }
    @font-face {
        font-family: 'Montserrat-Regular';
        src: url('assets/fonts/Montserrat/Montserrat-Regular.ttf') format('truetype');
    }
    @font-face {
        font-family: 'Montserrat-Medium';
        src: url('assets/fonts/Montserrat/Montserrat-Medium.ttf') format('truetype');
    }
    @font-face {
        font-family: 'Montserrat-Light';
        src: url('assets/fonts/Montserrat/Montserrat-Light.ttf') format('truetype');
    }

    @font-face {
        font-family: 'Montserrat-SemiBold';
        src: url('assets/fonts/Montserrat/Montserrat-SemiBold.ttf') format('truetype');
    }

    #app {
        font-family: 'Montser', Helvetica, Arial, sans-serif;
    }
    body {
        margin: 0;
        height: 100vh;
    }

    html {
        height: 100vh;
    }

    .card {
        background-color: white;
        border-width: 4px;
    }

    .table-row {
        height: 50px;
        font-family: Montserrat-Regular;
        td {
            font-family: Montserrat-Regular;
            /*border-top: 1px solid aqua;*/

        }

    }

    table {
        border-collapse: collapse;
    }

    $primary-color: #1880E1;
    $secondary-color: #41BC3F;
    $primary-color-btn: #5A78FF;

    $primary-gradient: linear-gradient(to right, #1880E2, #29B1CC);
    $primary-gradient-reverse: linear-gradient(to right, #1960bf, #29B1CC);

    $fail-color: #FF5E5E;
    $success-color: #7ED321;
    $warning-color: #F5A623;
    $digital-color: #1880E1;

    $expired-color: #8B572A;

    $black-100: #4A4A4A;
    $black-90: #6B6C6F;
    $black-80: #9B9B9B;


    $white-100: #FFFFFF;
    $white-90: #F9F9FA;
    $white-85: #F6F7F9;
    $white-80: #F2F3F5;
    $white-70: #DFE2E6;
    $white-50: #D8D8D8;

    $font-large: 1em;
    $font-normal: 0.875em;
    $font-medium: 0.8125em;
    $font-small: 0.75em;
    $font-btn: 13.3333px;

    $margin-jumbo: 24px;
    $margin-large: 16px;
    $margin-medium: 12px;
    $margin-decimal: 10px;
    $margin-small: 8px;
    $margin-nano: 4px;
    $padding-btn: 10px 20px;
    $padding-btn-outline: 8px 20px;

    $radius-100: 100em;
    $radius-btn: 18px;
    $radius-large: 8px;
    $radius-medium: 6px;
    $radius-small: 4px;
    $radius-none: 0px;

    $shadow-primary: 0 10px 20px rgba(41, 177, 204, 0.30);
    $shadow-secondary: 0 0px 8px rgba(41, 177, 204, 0.75);
    $shadow-card: 0 10px 20px rgba(41, 177, 204, 0.30);
    $shadow-btn: 0 0px 8px rgba(90, 120, 255, 0.75);

    $calendar-icon: 'assets/calendar.svg';
    $search-icon: 'assets/search.svg';
    $chevron-icon: 'assets/chevron-down.svg';
    $eye-icon: 'assets/chevron-down.svg';
    $key-icon: 'assets/key.svg';
    $user-icon: 'assets/user-input.svg';
    $users-checked-icon: 'assets/users-checked.svg';
    $mail-icon: 'assets/mail.svg';

    * {
        box-sizing: border-box;
    }

    .sub-p {
        font-size: 0.9375em;
        font-weight: 500;
    }

    body {
        font-family: 'Montser', Helvetica, Arial, sans-serif;
        color: $black-100;
        font-size: 1em;

        h1 {
            font-size: 2em;
            line-height: 2*1.5em;
            font-weight: 600;
        }

        h2 {
            font-size: 1.75em;
            line-height: 4.4em;
            font-weight: 600;
        }

        h3 {
            font-size: 1.5em;
            line-height: 1.5*1.5em;
            font-weight: 500;
        }

        h4 {
            font-size: 1.375em;
            line-height: 1.375*1.5em;
            font-weight: 600;
        }

        h5 {
            font-size: 1.125em;
            line-height: 1.125*1.5em;
            font-weight: 500;

            &.primary-color {
                color: $primary-color;
            }
        }

        h6 {
            font-size: 1em;
            line-height: 1*1.5em;
            font-weight: 400;
        }

        p {
            font-size: 0.875em;
            line-height: 0.875*1.5em;
            font-weight: 300;
        }

        label {
            font-size: 0.8125em;
            line-height: 0.8125*1.5em;
            font-weight: 400;
            color: $black-90;
        }

        a {
            color: $primary-color;
            text-decoration: none;
        }
    }

    .color
    {
        &-fail
        {
            color: $fail-color  ;
        }
    }

    .btn {
        padding: $padding-btn;
        font-size: $font-btn;
        font-weight: 600;
        line-height: $font-normal*1.5;
        text-align: center;
        color: $white-90;
        min-width: 175px;
        border: none;
        border-radius: $radius-btn;

        &:hover {
            cursor: pointer;
            box-shadow: $shadow-btn;
            color: $white-100;
            transition: box-shadow .18s ease-in;
        }

        &:focus {
            outline: none !important;
            box-shadow: $shadow-btn;
        }

        & .loader
        {
            margin: auto;
            border-top: 2px solid $warning-color !important;
        }

        &__primary {
            background: $primary-color-btn;
            font-family: Montserrat-SemiBold;

            &:active {
                transition: background .18s ease-out;
                background: $primary-color-btn;
            }

            &--outline {
                padding: $padding-btn-outline;
                border: 2px solid $primary-color;
                background: transparent;
                color: $primary-color;

                &:hover {
                    background: transparent;
                    box-shadow: none;
                    color: $primary-color;
                }
            }

            &--login {

                box-shadow: $shadow-primary;
                width: 100%;

                &:hover {
                    box-shadow: $shadow-primary;
                }
            }
        }

        &__small {
            background-color: $primary-color;
            padding: $margin-nano $margin-small;
            border-radius: $radius-small;
            font-size: $font-small;
            line-height: 1.8*$font-small;
            font-weight: 300;
            text-transform: uppercase;
            display: inline-block;
        }
    }

    .label {
        display: inline-block;
        border-radius: $radius-small;
        padding: $margin-nano;
        font-size: $font-small;
        font-weight: 600;
        line-height: $font-small*1.5;
        color: $white-100;
        font-family: Montserrat-Regular;
        background: $black-100;
        min-width: 64px;
        text-align: center;

        &--rejected {
            background: $fail-color;
        }

        &--paid {
            background: $digital-color;
        }
        &--search {
            font-family: Montserrat-Regular;
        }

        &--accepted {
            background: $success-color;
        }

        &--created {
            background: $black-100;
        }

        &--invalid {
            background: $warning-color;
        }

        &--expired {
            background: $expired-color;
        }

        &--canceled {
            background: $black-90;
        }
    }

    .input {
        font-size: $font-medium;
        line-height: 1.5*$font-medium;
        font-family: Montserrat-Regular;
        color: $black-100;

        &:focus {
            outline: none !important;
            transition: border-color .1s ease-in;
            border-color: $primary-color;
        }


        &__round {
            background: $white-100;
            padding: $margin-decimal;
            border-radius: $radius-100;
            border: 1px solid $white-70;

            &.err {
                border-color: $fail-color;
            }
        }

        &__underline {
            background: $white-100;
            padding: 5px;
            border: none;
            border-bottom: 2px solid $white-50;

            &:disabled {
                background: $white-80;
            }

            &.err {
                border-bottom-color: $fail-color;
            }

        }

        &__gray {
            background: $white-80;
            padding: $margin-decimal;
            border: none;
            border-bottom: 2px solid $white-50;

        }

        &--status-search {
            min-width: 150px !important;
            cursor: pointer;
        }

        &--search {
            background: $white-100 url($search-icon) no-repeat $margin-large center;
            padding-left: 4*$margin-medium;
            font-family: Montserrat-Regular;
        }

        &--mail {
            background: url($mail-icon) no-repeat $margin-large center;
            padding-left: 4*$margin-medium;
        }

        &--user {
            background: url($user-icon) no-repeat $margin-large center;
            padding-left: 4*$margin-medium;
        }


        &--key {
            background: url($key-icon) no-repeat $margin-large center;
            padding-left: 4*$margin-medium;
        }


        &--users-checked {
            background: url($users-checked-icon) no-repeat $margin-large center;
            padding-left: 4*$margin-medium;
        }

        &--calendar {
            background: $white-100 url($calendar-icon) no-repeat $margin-large center;
            padding-left: 4*$margin-medium;


            & input {
                border: none !important;
                font-size: 12px !important;
                line-height: 1.5*$font-medium !important;
                color: $black-100 !important;
                font-family: Montserrat-Regular !important;


                &::placeholder {
                    color: $black-80;
                }

                &:focus {
                    outline: none;
                }
            }
        }
        &--calendar-invoice {
            padding: 0px 0px 5px 0px;

            & input {
                border: none !important;
                background: $white-100 url($calendar-icon) no-repeat $margin-large center;
                font-size: 14px !important;
                padding: 5px 20px 5px 4*$margin-medium;
                line-height: 1.5*$font-medium !important;
                color: $black-100 !important;
                font-family: Montserrat-Regular !important;

                &::placeholder {
                    color: $black-80;
                }

                &:focus {
                    outline: none;
                }
            }
        }
        &--dropdown {
            background: $white-100 url($chevron-icon) no-repeat calc(100% - 16px) center;
            padding: 6px $margin-decimal;
            padding-right: 3*$margin-medium;
            min-width: 100px;
            max-width: calc(100% - 36px);
            min-height: unset;
            position: relative;

            & .multiselect {
                &__select {
                    display: none;
                }

                &__input {
                    /*display: none;*/
                    position: absolute;
                    left: 0;
                    padding: 5px $margin-decimal;
                    color: $black-100;
                    top: 0;
                    opacity: 0;
                    background: transparent;
                    border: 0;
                    width: 100%;
                    height: 100%;
                    font-size: $font-normal;
                    cursor:pointer;
                }

                &__single {
                    font-size: $font-normal;
                    color: $black-100;
                    margin-bottom: 0;

                }

                &__placeholder {
                    margin-bottom: 0;
                    padding-top: 5px;
                    font-size: $font-normal;

                    &::placeholder {
                        color: $black-80;
                    }
                }

                &__content-wrapper {
                    left: 0;
                    top: calc(100% + 2px);
                    border-radius: $radius-small;
                }

                &__spiner {
                    display: none;
                }

                &__tags {
                    border: 0;
                    padding: 0;
                    height: 24px;
                    min-height: unset;
                }

                &__tag {
                    margin-bottom: 0;
                }
            }
        }
    }

    .form {
        padding: $margin-jumbo;
        border-bottom: 1px solid $white-50;
        font-family: Montserrat-Regular;

        &__group {
            & > label {
                display: block;
                padding-left: $margin-large;
                margin-bottom: $margin-decimal;
                position: relative;

            }

            &--spaced {
                margin-bottom: $margin-large;

                &:last-child {
                    margin-bottom: 0;
                }
            }

            &--inline {
                & > label {
                    margin-bottom: 0;
                    margin-right: $margin-decimal;
                }

                display: flex;
                align-items: flex-end;
            }
        }

        &__error {
            border-radius: $radius-small;
            background-color: $fail-color;
            color: $white-100;
            font-size: $font-small;
            font-weight: 400;
            padding: $margin-nano;
            margin-left: $margin-decimal;
            position: relative;
            &:before {
                content: "";
                display: block;
                width: 0;
                height: 0;
                border-top: 4px solid transparent;
                border-bottom: 4px solid transparent;

                border-right: 4px solid $fail-color;
                position: absolute;
                left: -4px;
                top: 50%;
                transform: translateY(-50%);

            }
        }

        &__actions {
            padding: $margin-large $margin-jumbo;
        }

        &--inline {
            display: flex;
            align-items: center;
            justify-content: space-between !important;

            & > * {
                margin-right: $margin-jumbo;

                & > input {
                    width: 100%;
                }
            }
        }
    }

    .card {
        background-color: $white-100;
        border: 1px solid $white-70;
        border-radius: $radius-large;
        margin-top: $margin-jumbo;

        &--spaced {
            padding: $margin-jumbo;
        }
    }

    .container {
        display: flex;
    }

    .main-content {
        flex: 1;
        background-color: $white-80;
        padding: 0 2*$margin-jumbo;
    }

    table {
        margin: 0;
        border-radius: $radius-large;
        overflow: hidden;
        width: 100%;

        &.simple {
            margin: $margin-large 0;

            & td {
                border-top: 0;
                border-bottom: 1px solid $white-50;
                padding: $margin-small $margin-medium;
                font-family: Montserrat-Regular;
            }
        }

        th {
            background-color: $white-90;
            text-align: left;
            font-size: $font-normal;
            line-height: 1.5*$font-normal;
            font-weight: 400;
            color: $primary-color;
            font-family: Montserrat-Regular;
            padding: $margin-large $margin-medium;

            .pg {
                &-chevron-down,
                &-chevron-up {
                    padding-left: 4px;
                    font-size: 6px;
                    color: $black-80;
                }

                &.active {
                    color: $secondary-color;
                }
            }

            & > .column-order {
                display: flex;
                align-items: center;
                width: fit-content;
                opacity: 0.8;


                &:hover {
                    cursor: pointer;
                    opacity: 1;
                    transition: opacity 0.1s ease-in;
                }
            }
        }

        td {
            background-color: $white-100;
            text-align: left;
            font-size: $font-normal;
            line-height: 2*$font-normal;
            font-weight: 400;
            color: $black-100;
            border-top: 1px solid $white-50;
            padding: $margin-large $margin-medium;
        }

        tr
        {
            &.fixed-inputs
            {
                input
                {
                    width: 100% !important;
                }
            }
        }

        &.has-links {
            tr:nth-child(n+2) {

                &:hover {
                    cursor: pointer;

                    & td {
                        background-color: $white-90;
                        transition: background-color 0.15s ease-in;
                    }
                }
            }
        }
    }

    .paginate {
        padding: 0 $margin-decimal;

        &__wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            margin: $margin-large 0;
            font-family: Montserrat-SemiBold;
        }

        & > li {
            display: inline-block;
            background-color: $white-100;
            min-width: 36px;

            border: 1px solid $white-50;
            border-right: 0;

            &:nth-child(2) {
                border-right: 0;
                border-top-left-radius: $radius-small;
                border-bottom-left-radius: $radius-small;
                border-left: 1px solid $white-50;
                margin-right: -4px;
            }

            &:nth-last-child(2) {
                border-top-right-radius: $radius-small;
                border-bottom-right-radius: $radius-small;
                border-right: 1px solid $white-50;
                margin-left: -4px;
            }

            &:first-child,
            &:last-child {
                border: 1px solid $white-50;
                border-radius: $radius-small;
            }

            /*&:focus {
                outline: none !important;
                border-color: $primary-color;
                transition: background-color .15s ease-in, border-color .15s ease-in;
            }*/

            & > a {
                display: block;
                font-size: $font-normal;
                line-height: 1.5*$font-normal;
                color: $primary-color;
                text-align: center;
                padding: $margin-small $margin-decimal;
                margin: 0;

                &:focus {
                    outline: none !important;
                }


            }

            &.active {
                & > a {
                    background-color: $white-80;
                    color: #999;
                    border-color: #aaa;
                    transition: background-color .15s ease-in, border-color .15s ease-in;
                }
            }

            &.disabled {
                opacity: 0.5;
            }

        }
    }

    .tabs {
        display: flex;

        & > * {
            font-size: $font-large;
            font-weight: 300;
            text-transform: uppercase;
            color: $black-80;
            margin-right: $margin-jumbo;
            padding: $margin-medium 0;

            &.router-link-exact-active {
                color: $primary-color;
                font-weight: 600;
                position: relative;

                &:before {
                    content: '';
                    display: block;
                    height: 5px;
                    width: 100%;
                    background-color: $primary-color;
                    border-radius: $radius-100;
                    position: absolute;
                    top: calc(100% + 8px);
                }
            }
        }

        &__header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-bottom: $margin-decimal;
            border-bottom: 1px solid $white-50;
        }
    }

    .sidebar {
        display: flex;
        flex-direction: column;
        width: 65px;
        height: 100vh;
        transition: width .25s ease-in-out;

        .logo {
            width: 100%;
            max-width: 160px;

            &__wrapper {
                width: 100%;
                text-align: center;
                padding: $margin-jumbo 0;
            }
        }

        .role-type {
            font-size: $font-normal;
            font-weight: 400;
            text-transform: uppercase;
            text-align: center;
            color: $primary-color;
            padding: $margin-decimal 0;
        }

        .route-button {
            font-size: $font-normal;
            font-family: Montserrat-Regular;
            font-weight: 300;
            text-transform: capitalize;
            text-align: left;
            color: $black-90;
            padding: $margin-decimal;
            margin-bottom: $margin-decimal;
            display: flex;
            align-items: center;

            & > span {
                visibility: hidden;
                opacity: 0;
                position: absolute;
                transition: opacity .3s ease-in-out;
            }

            & .pg {
                margin-right: $margin-decimal;
                margin-left: $margin-decimal;
                font-size: 20px;
                color: $primary-color;
            }

            &--collapse {
                position: absolute;
                bottom: $margin-jumbo;
                cursor: pointer;
            }

        }

        .router-link-active {
            background-color: $primary-color;
            color: white;

            & .pg {
                color: $white-100;

            }
        }

        &.active {
            width: 192px;
            transition: width .25s ease-in-out;

            .route-button {

                & > span {
                    visibility: visible;
                    opacity: 1;
                    position: relative;
                    transition: opacity .3s ease-in-out;
                }
            }
        }
    }

</style>
